export interface Key {
  key: number;
  name: string;
}

export const keys: Record<string, Key> = {
  Enter: { key: 13, name: 'Enter' },
};

export const isKeyEnter = (event: Pick<KeyboardEvent, 'keyCode' | 'key'>): boolean => {
  if (event.keyCode && event.keyCode === keys.Enter.key) {
    return true;
  }

  if (event.key && event.key === keys.Enter.name) {
    return true;
  }

  return false;
};

// The ASCIICode range 48-57 returns numbers 0 to 9
export const isKeyNumber = (event: Pick<KeyboardEvent, 'keyCode' | 'which'>): boolean => {
  const ASCIICode = event.which || event.keyCode;

  return ASCIICode >= 48 && ASCIICode <= 57;
};
